import styled from "styled-components";
import { Box } from "@mui/material";
import { StyledCard as BaseStyledCard } from "../styled";

export const StyledCard = BaseStyledCard;

export const HeaderCell = styled(Box)`
  padding: 16px;
  background-color: white;
  font-weight: bold;
  border-bottom: 2px solid #e0e0e0;
`;

export const DataCell = styled(Box)`
  padding: 16px;
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
`;
